import DataTableReadDto from "./DataTableReadDto";

class PathDataTableReadDto extends DataTableReadDto {
    PathId: number | null;
    PathName: string;

    constructor(
        pathId: number | null,
        pathName: string,
    ) {
        super();
        this.PathId = pathId;
        this.PathName = pathName;
    }

    public override get Label(): string {
        return this.PathName;
    }

}

export default PathDataTableReadDto;
